<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
          <a-input
            placeholder="请输入姓名"
            :max-length="16"
            v-decorator="['name', validatorRules.name]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别">
          <a-select
            placeholder="请选择"
            v-decorator="['sex', validatorRules.sex]"
          >
            <a-select-option :value="0">女</a-select-option>
            <a-select-option :value="1">男</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="证书编号"
        >
          <a-input
            placeholder="请输入证书编号"
            :max-length="25"
            v-decorator="['certNumber', validatorRules.certNumber]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="职业岗位"
        >
          <a-input
            placeholder="请输入职业岗位"
            :max-length="16"
            v-decorator="['position', validatorRules.position]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
export default {
  data() {
    return {
      title: '新增',
      visible: false,
      // model:'year',
      model: {},
      typeText: '',
      value: '',
      yearPick: null,
      yearPickShow: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        position: { rules: [{ required: true, message: '请输入执业岗位!' }] },
        name: { rules: [{ required: true, message: '请输入姓名!' }] },
        sex: { rules: [{ required: true, message: '请选择性别!' }] },
        certNumber: { rules: [{ required: true, message: '请输入证书编号!' }] }
      },
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/person/save',
        edit: process.env.VUE_APP_CMS_CONTENT + '/cont/person/save'
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'position', 'name', 'sex', 'certNumber')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange() {},
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'POST';
          } else {
            httpurl += this.url.edit;
            method = 'POST';
          }
          let formData = Object.assign(this.model, values);
          formData.personType = 0;
          console.log(this.model);
          //时间格式化
          httpAction(httpurl, formData, method).then(res => {
            console.log(res);
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', that.model);
              that.confirmLoading = false;
              that.close();
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleOpenChange(status) {
      console.log(status, '============');
      this.yearPickShow = status;
    },
    // 得到年份选择器的值
    handlePanelChange(value) {
      console.log(value);
      this.yearPick = value;
      console.log(this.yearPick);
      this.yearPickShow = false;
    }
  }
};
</script>

<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
